import React, { useEffect, Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes, { func } from 'prop-types';
import { Alert, Table, Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { QUANTITY } from '@Apis/constants';
import StockAgeingReportHeader from '../StockAgeingReportHeader';

/**
 *
 */
function StockAgeingReportTable({
  user,
  history, MONEY, StockAgeingReportData, getStockAgeingReportsLoading, getStockAgeingReports,

}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(user?.tenant_info?.tenant_id);
  const [department, setDepartment] = useState('');
  const [selectedMethod, setSelectedMethod] = useState('cost_price');
  const [selectedDate, setSelectedDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [intervals, setIntervals] = useState(0);
  const [noOfColumns, setNoOfColumns] = useState(5);
  const [selectedCategory, setSelectedCategory] = useState([]);

  /**
   *
   * @param {*} keyword
   * @param {*} status
   * @param {*} stockType
   * @param {*} productCategory
   * @param {*} page
   * @param {*} limit
   */
  const pushParamsToUrl = (date, tenant, selectedDepartment, method, interval, steps, page, currentLimit, category) => {
    let url = 'stock_ageing_report?';
    if (date) url += `&date=${date}`;
    if (tenant) url += `&tenant_ids=${tenant}`;
    if (selectedDepartment) url += `&department_id=${selectedDepartment}`;
    if (method) url += `&method=${method}`;
    if (interval) url += `&interval=${interval}`;
    if (steps) url += `&steps=${steps}`;
    if (page) url += `&page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (category) url += `&category=${category}`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      setSelectedMethod(Helpers.getValueFromUrl('method') || selectedMethod);
      setSelectedTenant(Helpers.getValueFromUrl('tenant_ids') ? Helpers.getValueFromUrl('tenant_ids')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      setSelectedDate(dayjs(Helpers.getValueFromUrl('date') || selectedDate));
      setDepartment(Helpers.getValueFromUrl('department_id') ? Number(Helpers.getValueFromUrl('department_id')) : '');
      setIntervals(Helpers.getValueFromUrl('interval') || 30);
      setNoOfColumns(Helpers.getValueFromUrl('steps') || 5);
      setSelectedCategory(Helpers.getValueFromUrl('category')?.split(',')?.filter(Boolean)?.map(Number) || []);
      setIsUserReady(true);
    }
  }, []);

  // useEffect(() => {
  //   if (user?.tenant_info?.tenant_id) {
  //     getStockAgeingReports(selectedTenant, selectedMethod, intervals, noOfColumns, dayjs().subtract(1, 'month').format('YYYY-MM-DD'), department, currentPage, limit,
  //       (valueOfCallback) => {
  //         setNewData(valueOfCallback);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    if (isUserReady) {
      const Date = selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
      pushParamsToUrl(Date, selectedTenant, department, selectedMethod, intervals, noOfColumns, currentPage, limit, selectedCategory);

      // getStockAgeingReports(selectedTenant, selectedMethod, intervals, noOfColumns, Date, department, currentPage, limit,
      //   (valueOfCallback) => {
      //     setNewData(valueOfCallback);
      //   });
      getStockAgeingReports(
        selectedTenant,
        Helpers.getValueFromUrl('method'), Helpers.getValueFromUrl('interval'), Helpers.getValueFromUrl('steps'),
        Helpers.getValueFromUrl('date'), Helpers.getValueFromUrl('department_id'), Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('category'),
      );
    }
  }, [selectedTenant, department, currentPage, limit, selectedCategory]);

  /**
   *
   * @param {*} data
   * @return
   */

  function convertDateRangeKeysQty(item) {
    const convertedItem = {};
    Object.keys(item).forEach((key) => {
      if (key.startsWith('qty_') && key.endsWith('_days')) {
        convertedItem[key] = item[key];
      }
    });
    return convertedItem;
  }

  function convertDateRangeKeysStocks(item) {
    const convertedItem = {};
    Object.keys(item).forEach((key) => {
      if (key.startsWith('stock_value_') && key.endsWith('_days')) {
        convertedItem[key] = item[key];
      }
    });
    return convertedItem;
  }

  const qytAndDays = StockAgeingReportData?.map(convertDateRangeKeysQty);
  const StocksAndDays = StockAgeingReportData?.map(convertDateRangeKeysStocks);

  const getColumns = () => {
    const moColumnsRM = [
      {
        title: 'PRODUCT',
        width: '180px',
        fixed: 'left',
        render: (record) => (
          <Fragment>
            <Link target="_blank" to={`/inventory/product/view/${record?.product_sku_id}`}>
              <H3Text text={record?.internal_sku_code} />
            </Link>
            <H3Text text={`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''} ${record?.product_sku_name}`?.trim()} className="prod-table__text" />
            {record?.product_category_info?.category_path && (
              <Tooltip
                overlay={(
                  <div
                    style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '12px',
                      fontWeight: '500',
                      padding: '2px',
                    }}
                  >
                    {record.product_category_info.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                {' '}
                {/* Tooltip wrapping the div */}
                <div
                  className="category__status_tag"
                  style={{ backgroundColor: '#3aa5a6' }}
                >
                  {/* Displaying only the last category name with ellipsis if path is long */}
                  {record?.product_category_info ? (
                 `.../${record?.product_category_info?.product_category_name}`
                  ) : (
                    ''
                  )}
                </div>
              </Tooltip>
            )}
          </Fragment>
        ),
      },
    ];

    // Dynamically add columns based on data
    if (qytAndDays?.length > 0 && StocksAndDays?.length > 0) {
      const keys = Object.keys(qytAndDays[0]);
      const stocksKeys = Object.keys(StocksAndDays[0]);
      keys.forEach((key) => {
        moColumnsRM.push({
          title: `${key.replace(/qty_(\d+(?:_\d+)?)(?:_(plus))?_days/, (_, digits, plus) => {
            if (plus) {
              return `${digits.replace(/_/g, '-')} Plus Days`;
            }
            return `${digits.replace(/_/g, '-')} Days`;
          })}`,
          children: [
            {
              title: 'Qty',
              width: '50px',
              render: (record) => (
                <div>
                  {record?.[key] !== undefined ? `${QUANTITY(record?.[key])} ${record?.uom_info?.uqc?.toProperCase() || ''}` : ''}
                </div>
              ),
            },
            {
              title: 'Value',
              width: '50px',
              render: (record) => (
                <div>
                  {stocksKeys.map((item) => {
                    if (item === key.replace('qty', 'stock_value')) {
                      return record?.[item] !== undefined ? MONEY(record?.[item]) : '';
                    }
                    return null;
                  })}
                </div>
              ),
            },
          ],
        });
      });
    }
    return moColumnsRM;
  };

  const getDataSource = () => {
    const tempData = [];
    const operationData = StockAgeingReportData || [];
    for (let i = 0; i < operationData?.length; i++) {
      tempData.push({
        ...operationData[i],
        key: uuidv4(),
      });
    }
    return tempData;
  };

  return (
    <Fragment>
      <div className="view-stock-ageing__report__wrapper">
        <StockAgeingReportHeader
          selectedTenant={selectedTenant}
          department={department}
          selectedDate={selectedDate}
          selectedMethod={selectedMethod}
          noOfColumns={noOfColumns}
          intervals={intervals}
          limit={limit}
          currentPage={currentPage}
          setIntervals={setIntervals}
          setSelectedTenant={setSelectedTenant}
          setDepartment={setDepartment}
          setNoOfColumns={setNoOfColumns}
          setSelectedMethod={setSelectedMethod}
          setSelectedDate={setSelectedDate}
          setCurrentPage={setCurrentPage}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}

        />
        <div className="generic-table-container reports-table-container">

          <Table
            loading={getStockAgeingReportsLoading}
            bordered
            showHeader
            size="small"
            scroll={{ x: 'max-content' }}
            columns={getColumns()}
            dataSource={getDataSource()}
            pagination={{
              total: getDataSource()?.length === 50 ? (currentPage > 1 && getDataSource()?.length < 50 ? (((currentPage - 1) * 50) + getDataSource()?.length) : (currentPage * 50) + 1) : ((50 * (currentPage - 1)) + getDataSource()?.length),
              pageSize: limit,
              showSizeChanger: false,
              onChange: (page, pageSize) => {
                setCurrentPage(page);
                setLimit(pageSize);
              },
              position: ['bottomLeft'],
              showTotal: () => (
                <div className="reports-table__footer">
                  <H3Text text={`Showing ${((currentPage - 1) * 50) + 1} - ${getDataSource()?.length + ((currentPage - 1) * 50)} Records`} className="reports-table__footer-text" />
                  <Alert
                    showIcon
                    type="info"
                    message="You can only view 50 records at a time. Please download the report to view all records"
                  />
                </div>
              ),
            }}
          />

        </div>
      </div>

    </Fragment>
  );
}

const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getStockAgeingReportsLoading: ReportReducers.getStockAgeingReportsLoading,
  StockAgeingReportData: ReportReducers.StockAgeingReportData,
});
const mapDispatchToProps = (dispatch) => ({
  getStockAgeingReports: (tenantIds, method, interval, steps, date, departmentId, page, item, callback) => dispatch(ReportActions.getStockAgeingReports(tenantIds, method, interval, steps, date, departmentId, page, item, callback)),
});

StockAgeingReportTable.propTypes = {
  history: PropTypes.func,
  getStockAgeingReports: PropTypes.any,
  user: PropTypes.any,
  MONEY: PropTypes.any,
  StockAgeingReportData: PropTypes.any,
  getStockAgeingReportsLoading: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StockAgeingReportTable));
